import { render, staticRenderFns } from "./NewUserCredentials.vue?vue&type=template&id=31f3c6a8"
import script from "./NewUserCredentials.vue?vue&type=script&lang=js"
export * from "./NewUserCredentials.vue?vue&type=script&lang=js"
import style0 from "./NewUserCredentials.vue?vue&type=style&index=0&id=31f3c6a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports